import {
  apiGet,
  apiPost,
  apiPut,
  apiPutMultipart,
  apiPostMultipart,
  apiDelete,
} from 'helpers/ApiHelper';
import Auth from 'j-toker';
import * as notifications from './notificationActions';
import * as dashboardActions from './dashboardActions';
import * as tenantMaintenance from './tenantMaintenanceActions';
import * as maintenanceTicket from './maintenanceTicketActions';

import { objectToQuery, toISO8601DateString, toDate, combineDateAndTime } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';

export function completeMaintenanceTicketStep1() {
  return {
    type: 'COMPLETE_TICKET_STEP_1',
  };
}

export function backToMaintenanceTicketStep1() {
  return {
    type: 'BACK_TO_TICKET_STEP_1',
  };
}

export function enableSignButton(boolean, png_base64) {
  return {
    type: 'ENABLE_SIGN_BUTTON',
    boolean: boolean,
    image: png_base64,
  };
}

export function getListOfPropertiesAndMaintenance() {
  return (dispatch) => {
    return dispatch({
      payload: dispatch(getListOfProperties())
        .done(() => {
          dispatch(getListOfMaintenanceStaff());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getListOfMaintenanceWorkerProperties() {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/maintenance/list_properties`)
        .done((response) => {
          dispatch(savePropertyList(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getListOfUnitsMaintenanceWorker(property_id) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/maintenance/list_units?property_id=${property_id}`)
        .done((response) => {
          dispatch(saveUnitList(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

// @deprecated use getProperties from landlordPropertiesActions
export function getListOfProperties() {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/list_all_properties`)
        .done((response) => {
          if (!response.data) {
            dispatch(savePropertyList(response));
          }
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getListOfCompanyTags() {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/list_all_maintenance_tags`)
        .done((response) => {
          dispatch(displayCompanyTags(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayCompanyTags(response) {
  return {
    type: 'COMPANY_TAGS',
    maintenanceTags: response,
  };
}

export function savePropertyList(response) {
  return {
    type: 'SAVE_PROPERTY_LIST',
    properties: response,
  };
}

export function getListOfMaintenanceStaff(property_id, options) {
  property_id = property_id === undefined ? '' : property_id;

  let getListOfAgentsAndMaintenancePath = `/landlords/list_all_agents_and_maintenance?property_id=${property_id}`;
  if (options && options.agents_only) {
    getListOfAgentsAndMaintenancePath += '&agents_only=true';
  }

  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + getListOfAgentsAndMaintenancePath)
        .done((response) => {
          dispatch(saveMaintenanceListAndGroupings(response.employees));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function saveMaintenanceListAndGroupings(response) {
  const array = response;
  const val = array[array.length - 1];
  return {
    type: 'SAVE_MAINTENANCE_LIST',
    maintenance: response,
    assignment: val,
  };
}

export function getAllAgentsAndMaintenanceForProperties(property_ids) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/agents_and_maintenance', {
        property_ids: property_ids,
      })
        .done((response) => {
          dispatch(
            saveAgentAndMaintenanceListAndGroupings(response.all_agents_and_maintenance_list)
          );
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function saveAgentAndMaintenanceListAndGroupings(response) {
  const array = response;
  const val = array[array.length - 1];
  return {
    type: 'SAVE_EMPLOYEE_LIST',
    all_agents_and_maintenance_list: response,
    assignment: val,
  };
}

export function getMaintenanceCategories(propertyId) {
  let getMaintenanceCategoriesPath = `/landlords/maintenance_categories`;
  if (propertyId) {
    getMaintenanceCategoriesPath += `?property_id=${propertyId}`;
  }

  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + getMaintenanceCategoriesPath)
        .done((response) => {
          dispatch(saveMaintenanceCategories(response.categories));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function saveMaintenanceCategories(response) {
  return {
    type: 'SAVE_MAINTENANCE_CATEGORIES',
    maintenanceCategories: response,
  };
}

export function getMaintenanceLocations(propertyId) {
  let getMaintenanceLocationsPath = `/landlords/maintenance_locations`;
  if (propertyId) {
    getMaintenanceLocationsPath += `?property_id=${propertyId}`;
  }

  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + getMaintenanceLocationsPath)
        .done((response) => {
          dispatch(saveMaintenanceLocations(response.locations));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function saveMaintenanceLocations(response) {
  return {
    type: 'SAVE_MAINTENANCE_LOCATIONS',
    maintenanceLocations: response,
  };
}

export function getListOfAgents() {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/agents`)
        .done((response) => {
          dispatch(saveAgents(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveAgents(agents) {
  return {
    type: 'MAINTENANCE::SAVE_AGENTS',
    agents,
  };
}

// @deprecated use getUnits from landlordPropertiesActions
export function getListOfUnits(property_id) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/list_all_units?property_id=${property_id}`)
        .done((response) => {
          dispatch(saveUnitList(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveUnitList(response) {
  return {
    type: 'SAVE_UNIT_LIST',
    units: response,
  };
}

export function showTenantList(unit_id, property_id) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() +
          `/landlords/list_all_tenants?property_id=${property_id}&unit_id=${unit_id}`
      )
        .done((response) => {
          dispatch(displayTenantList(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayTenantList(response) {
  return {
    type: 'SHOW_TENANT_LIST',
    tenants: response,
  };
}

export function hideTenantList(response) {
  return {
    type: 'HIDE_TENANT_LIST',
  };
}

export function clearReducer() {
  return {
    type: 'CLEAR',
  };
}

// legacy action for creating and updating tickets
export function createOrUpdateMaintenanceTicket(data, maintenanceTicketID) {
  if (data["completion_date"] && typeof data["completion_date"] === 'object') {
    data["completion_date"] = data["completion_date"].format('YYYY-MM-DD HH:mm')
  }

  let data_clone = JSON.parse(JSON.stringify(data));
  const multiPartFormData = new FormData();

  let verbiage = 'ticketSuccessfullyCreated';
  if (maintenanceTicketID) {
    verbiage = 'ticketSuccessfullyUpdated';
  }

  if (deepDiver(data, 'files.0.lastModified')) {
    for (var i = 0; i < data['files'].length; i++) {
      multiPartFormData.append(`file_${i}`, data['files'][i]);
    }
  }

  if (deepDiver(data, 'attachment.0.lastModified')) {
    multiPartFormData.append('attachment', data.attachment[0]);
  }

  if (deepDiver(data, 'vendor.value')) {
    data_clone['vendor_id'] = deepDiver(data, 'vendor.value');
  }

  if (data['scheduled_at']) {
    data_clone['scheduled_at'] = formatScheduleAtDate(data['scheduled_at']);
  }

  if (data_clone['schedule_start_date']) {
    data_clone['schedule_start_date'] = toISO8601DateString(data_clone['schedule_start_date']);
  }

  if (data_clone['schedule_end_date']) {
    data_clone['schedule_end_date'] = toISO8601DateString(data_clone['schedule_end_date']);
  }

  data_clone['is_tenant_damaged'] = !!data_clone['is_tenant_damaged']; // when not toggled, it becomes "". This forces booleans are sent.
  if (data_clone['scheduled_starts_at_date'] && data_clone['scheduled_starts_at_time']) {
    data_clone['scheduled_starts_at'] = combineDateAndTime(
      data_clone['scheduled_starts_at_date'],
      data_clone['scheduled_starts_at_time']
    );
  }

  if (data_clone['property']) {
    data_clone['property_id'] = deepDiver(data, 'property.value');
    delete data_clone['property'];
  }
  if (data_clone['unit']) {
    data_clone['unit_id'] = deepDiver(data, 'unit.value');
    delete data_clone['unit'];
  }
  if (data_clone['room']) {
    data_clone['room_id'] = deepDiver(data, 'room.value');
    delete data_clone['room'];
  }
  if (data_clone['asset']) {
    data_clone['asset_id'] = deepDiver(data, 'asset.value');
    delete data_clone['asset'];
  }

  multiPartFormData.append('data', JSON.stringify(data_clone));

  return (dispatch) => {
    return dispatch({
      payload: maintenancePayload(maintenanceTicketID, multiPartFormData)
        .then((response) => {
          dispatch(notifications.showSuccess(verbiage));
          dispatch(notifications.hideLoader());
          return response;
        })
        .catch((error) => {
          if (error.responseJSON && error.responseJSON.error_code) {
            dispatch(notifications.showFailure(error.responseJSON.error_code));
          } else {
            dispatch(notifications.showFailure('unableToFindTicket'));
          }
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

export function postTicket(formData) {
  const multiPartFormData = new FormData();
  multiPartFormData.append('data', JSON.stringify(formData));
  if (deepDiver(formData, 'files.0.lastModified')) {
    for (var i = 0; i < formData['files'].length; i++) {
      multiPartFormData.append(`file_${i}`, formData['files'][i]);
    }
  }
  return (dispatch) => {
    const url = `${Auth.getApiUrl()}/landlords/maintenance_tickets`;
    return apiPostMultipart(url, multiPartFormData);
  };
}

function maintenancePayload(maintenanceTicketID, multiPartFormData) {
  if (maintenanceTicketID) {
    return apiPutMultipart(
      Auth.getApiUrl() + `/landlords/maintenance_tickets/${maintenanceTicketID}`,
      multiPartFormData
    );
  } else {
    return apiPostMultipart(Auth.getApiUrl() + '/landlords/maintenance_tickets', multiPartFormData);
  }
}

export function createOrUpdateMaintenanceTask(data, taskID, maintenanceTicketID) {
  let verbiage = 'taskSuccessfullyCreated';
  if (taskID) {
    verbiage = 'taskSuccessfullyUpdated';
  }

  return (dispatch) => {
    return dispatch({
      payload: taskPayload(maintenanceTicketID, taskID, data)
        .then((response) => {
          dispatch(notifications.showSuccess(verbiage));
          dispatch(maintenanceTicket.saveTicket(response.maintenance_ticket));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

function taskPayload(maintenanceTicketID, taskID, data) {
  if (taskID) {
    return apiPut(
      Auth.getApiUrl() + `/landlords/maintenance_tickets/${maintenanceTicketID}/tasks/${taskID}`,
      data
    );
  } else {
    return apiPost(
      Auth.getApiUrl() + `/landlords/maintenance_tickets/${maintenanceTicketID}/tasks`,
      data
    );
  }
}

export function deleteTask(taskID, maintenanceTicketID) {
  return (dispatch) => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/landlords/maintenance_tickets/${maintenanceTicketID}/tasks/${taskID}`
      )
        .then((response) => {
          dispatch(notifications.showSuccess('taskSuccessfullyDeleted'));
          dispatch(maintenanceTicket.saveTicket(response.maintenance_ticket));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

export function updateMaintenanceTicketWorker(data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone['scheduled_at'] = formatScheduleAtDate(data_clone['scheduled_at']);
  return (dispatch) => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/maintenance/status`, data_clone)
        .done((response) => {
          dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
          dispatch(maintenanceTicket.getMaintenanceWorkerTicket(response.ticket_number));
          dispatch(dashboardActions.closeMaintenanceDialog(response.ticket_number));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function cancelMaintenanceTicket(id) {
  return (dispatch) => {
    return dispatch({
      type: 'DESTROY_MAINTENANCE_TICKET',
      payload: apiDelete(Auth.getApiUrl() + `/landlords/maintenance_tickets/${id}`)
        .then(() => {
          dispatch(notifications.showSuccess('ticketSuccessfullyCancelled'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function createMaintenanceImage(formData) {
  const multipartFormData = new FormData();
  multipartFormData.append('ticket_number', formData.ticket_number);

  for (var i = 0; i < formData.images.length; i++) {
    multipartFormData.append(`file_${i}`, formData.images[i]);
  }

  return (dispatch) => {
    return dispatch({
      type: 'MAINTENANCE_IMAGE',
      payload: apiPostMultipart(
        Auth.getApiUrl() + '/landlords/upload_maintenance_photo_lead',
        multipartFormData
      )
        .then(() => {
          dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
          dispatch(tenantMaintenance.getTenantMaintenanceRequest());
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function deleteEscalationRule(escalationRuleID) {
  return (dispatch) => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/maintenance_escalation/${escalationRuleID}`)
        .done(() => {
          return dispatch(notifications.showSuccess('escalationRuleSuccessfullyDeleted'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
          throw Error;
        }),
    });
  };
}

export function getMaintenanceEscalationRules(propertyID) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + `/landlords/maintenance_escalation?property_id=${propertyID}`
      )
        .done((response) => {
          dispatch(saveMaintenanceEscalationRules(response.maintenance_escalations));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function saveMaintenanceEscalationRules(escalationRules) {
  return {
    type: 'MAINTENANCE_ESCALATION_RULES::SAVE_ESCALATION_RULES',
    escalationRules,
  };
}

export function createOrUpdateEscalationRule(formData) {
  let verbiage = 'Created';
  const escalationRuleID = formData['id'];
  if (escalationRuleID && escalationRuleID !== undefined) {
    verbiage = 'Updated';
  }

  const agentIDs = deepDiver(formData, 'agents').map((agentDetail) => agentDetail.value);
  formData['agent_ids'] = agentIDs;

  return (dispatch) => {
    return dispatch({
      payload: maintenanceEscalationPayload(formData, escalationRuleID)
        .then((response) => {
          dispatch(notifications.showSuccess(`Escalation Rule Successfully ${verbiage}.`));
          return response;
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

function maintenanceEscalationPayload(formData, escalationID) {
  if (escalationID && escalationID !== undefined) {
    return apiPut(Auth.getApiUrl() + `/landlords/maintenance_escalation/${escalationID}`, formData);
  } else {
    return apiPost(Auth.getApiUrl() + '/landlords/maintenance_escalation', formData);
  }
}

export function createTenantMaintenanceKioskRequest(data) {
  let dataClone = JSON.parse(JSON.stringify(data));

  dataClone['property_id'] = dataClone.property.value;
  delete dataClone['property'];
  if (dataClone.unit_selected && dataClone.unit_selected.value !== 'None') {
    dataClone['unit_id'] = dataClone.unit_selected.value;
  } else {
    dataClone['unit_id'] = null;
  }
  delete dataClone['unit_selected'];

  return (dispatch) => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/tenant_maintenance_kiosk_tickets', dataClone)
        .then((response) => {
          dispatch(notifications.showSuccess('ticketSuccessfullyCreated'));
          return response;
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

export function completeMaintenanceJob(data, time_spent, signature_png, ticketID) {
  let data_clone = JSON.parse(JSON.stringify(data));
  const multiPartFormData = new FormData();

  if (deepDiver(data, 'files.0.lastModified')) {
    for (var i = 0; i < data['files'].length; i++) {
      multiPartFormData.append(`file_${i}`, data['files'][i]);
    }
  }

  data_clone['time_spent'] = time_spent;
  data_clone['signature'] = signature_png;
  data_clone['ticket_id'] = ticketID;

  multiPartFormData.append('data', JSON.stringify(data_clone));

  return (dispatch) => {
    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + '/maintenance/complete_job', multiPartFormData)
        .then((response) => {
          dispatch(maintenanceTicket.getMaintenanceWorkerTicket(response.maintenance_ticket.id));
          dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
          return response;
        })
        .catch((error) => {
          if (error.responseJSON.maintenance_ticket) {
            dispatch(
              maintenanceTicket.getMaintenanceWorkerTicket(error.responseJSON.maintenance_ticket.id)
            );
          }
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function pauseMaintenanceJob(time_spent, ticketID) {
  const multiPartFormData = new FormData();

  const dataClone = {
    time_spent: time_spent,
    ticket_id: ticketID,
    internal_note: '',
  };

  multiPartFormData.append('data', JSON.stringify(dataClone));

  return (dispatch) => {
    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + `/maintenance/pause_job`, multiPartFormData)
        .done((response) => {
          dispatch(maintenanceTicket.saveTicket(response.maintenance_ticket));
          dispatch(notifications.showSuccess('jobSuccessfullyPaused'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function requireContractor(data, time_spent, ticketID) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone['time_spent'] = time_spent;
  data_clone['ticket_id'] = ticketID;

  return (dispatch) => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/maintenance/require_contractor`, data_clone)
        .done((response) => {
          dispatch(maintenanceTicket.saveTicket(response.maintenance_ticket));
          dispatch(notifications.showSuccess('contractorSuccessfullyRequested'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

let formatScheduleAtDate = (scheduled_at) => {
  let formattedScheduledAt = null;
  if (scheduled_at) {
    formattedScheduledAt = toISO8601DateString(scheduled_at);
  }
  return formattedScheduledAt;
};

// Maintenance Assets
export function getAssets(options) {
  // Options: show_inactive: true will return list of all maintenance assets.
  let route = '/landlords/maintenance_assets';
  if (options) {
    route += objectToQuery(options);
  }
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + route)
        .done((response) => {
          return dispatch(saveAsset(response.maintenance_assets));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveAsset(maintenanceAssets) {
  return {
    type: 'MAINTENANCE_ASSETS::SAVE_MAINTENANCE_ASSETS',
    maintenanceAssets,
  };
}

export function createOrUpdateMaintenanceAsset(data, maintenanceAssetID) {
  let data_clone = JSON.parse(JSON.stringify(data));
  const multiPartFormData = new FormData();

  if (deepDiver(data, 'files.0.lastModified')) {
    for (var i = 0; i < data['files'].length; i++) {
      multiPartFormData.append(`file_${i}`, data['files'][i]);
    }
  }

  if (data_clone['estimated_replacement_date']) {
    data_clone['estimated_replacement_date'] = toISO8601DateString(
      data_clone['estimated_replacement_date']
    );
  }

  if (data_clone['warranty_end_date']) {
    data_clone['warranty_end_date'] = toISO8601DateString(data_clone['warranty_end_date']);
  }

  if (data_clone['date_manufactured']) {
    data_clone['date_manufactured'] = toISO8601DateString(data_clone['date_manufactured']);
  }

  data_clone['property_id'] = deepDiver(data, 'property.value');
  data_clone['unit_id'] = deepDiver(data, 'unit.value');
  data_clone['room_id'] = deepDiver(data, 'room.value');

  delete data_clone['property'];
  delete data_clone['room'];
  delete data_clone['unit'];

  multiPartFormData.append('data', JSON.stringify(data_clone));

  const updatedOrCreated = maintenanceAssetID ? 'Updated' : 'Created';

  return (dispatch) => {
    return dispatch({
      payload: maintenanceAssetPayload(maintenanceAssetID, multiPartFormData)
        .then((response) => {
          dispatch(notifications.showSuccess(`Asset Successfully ${updatedOrCreated}.`));
          return response;
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

function maintenanceAssetPayload(maintenanceAssetID, multiPartFormData) {
  if (maintenanceAssetID) {
    return apiPutMultipart(
      Auth.getApiUrl() + `/landlords/maintenance_assets/${maintenanceAssetID}`,
      multiPartFormData
    );
  } else {
    return apiPostMultipart(Auth.getApiUrl() + '/landlords/maintenance_assets', multiPartFormData);
  }
}

export function getAssetDetails(maintenanceAssetID) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/maintenance_assets/${maintenanceAssetID}`)
        .then((response) => {
          return dispatch(saveMaintenanceAsset(response.maintenance_asset));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          dispatch(notifications.hideLoader());
        }),
    });
  };
}

export function saveMaintenanceAsset(maintenanceAsset) {
  if (maintenanceAsset['estimated_replacement_date']) {
    maintenanceAsset['estimated_replacement_date'] = toDate(
      maintenanceAsset['estimated_replacement_date']
    );
  }

  if (maintenanceAsset['warranty_end_date']) {
    maintenanceAsset['warranty_end_date'] = toDate(maintenanceAsset['warranty_end_date']);
  }

  if (maintenanceAsset['date_manufactured']) {
    maintenanceAsset['date_manufactured'] = toDate(maintenanceAsset['date_manufactured']);
  }

  return {
    type: 'MAINTENANCE_ASSETS::SAVE_MAINTENANCE_ASSET',
    maintenanceAsset,
  };
}

export function deleteAsset(assetID) {
  return (dispatch) => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/maintenance_assets/${assetID}`)
        .done((response) => {
          return dispatch(notifications.showSuccess('assetSuccessfullyDeleted'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function getRecurringTicketsCount() {
  const route = '/landlords/recurring_tickets_stats';
  return (dispatch) => {
    return dispatch({
      type: 'LANDLORD_MAINTENANCE::FETCH_RECURRING_TICKETS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done((response) => {
        dispatch({
          type: 'LANDLORD_MAINTENANCE::SAVE_RECURRING_TICKETS_STATS',
          payload: response.detailed_recurring_ticket_counts,
        });
      }),
    });
  };
}

export function getFilteredRecurringTickets(subset = 'all', offset = 0, options = {}) {
  return (dispatch) => {
    return dispatch({
      type: 'LANDLORD_MAINTENANCE::FETCH_RECURRING_TICKETS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_recurring_tickets?subset=${subset}&offset=${offset}`,
        options
      )
        .done((response) => {
          dispatch(saveRecurringTickets(response.recurring_tickets, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveRecurringTickets(response, timestamp, offset) {
  return {
    type: 'MAINTENANCE::SAVE_RECURRING_TICKETS',
    recurringTickets: response,
    timestamp,
    offset,
  };
}

export function updateMaintenanceTemplate(templateID, formData) {
  return (dispatch) => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/maintenance_templates/${templateID}`, formData)
        .done((response) => {
          return dispatch(notifications.showSuccess('templateSuccessfullyUpdated'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          return;
        }),
    });
  };
}

export function claimTicket(ticketID) {
  return (dispatch) => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/maintenance/maintenance_tickets/${ticketID}`)
        .done((response) => {
          return dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          return;
        }),
    });
  };
}

export function updatePartsContractorNeeded(ticketId, payload) {
  return (dispatch) => {
    const url = `${Auth.getApiUrl()}/maintenance/maintenance_tickets/${ticketId}/contractor_parts_needed_review`;
    return dispatch({
      payload: apiPut(url, payload)
        .done((response) => {
          return dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          throw error;
        }),
    });
  };
}

export function acceptDeclineProposedSchedule(ticketId, payload) {
  return (dispatch) => {
    const url = `${Auth.getApiUrl()}/maintenance/maintenance_tickets/${ticketId}/accept_or_decline_proposed_scheduled_date`;
    return dispatch({
      payload: apiPut(url, payload)
        .done((response) => {
          return dispatch(notifications.showSuccess('ticketSuccessfullyUpdated'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          throw error;
        }),
    });
  };
}
